exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clone-button[data-v-c6ce0560] {\n  display: inline;\n}\n", ""]);

// exports
